import React from 'react';


function Footer() {
    return (
        <div className='footer'> <div className="container-fluid d-flex justify-content-between">
        <nav className="pull-left">
            <ul className="nav">
                <li className="nav-item">
                    <a className="nav-link" href="#">
                        Admin
                    </a>
                </li>
                {/* <li className="nav-item">
                    <a className="nav-link" href="#"> Help </a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#"> Licenses </a>
                </li> */}
            </ul>
        </nav>
        <div className="copyright">
            {new Date().getFullYear()}, RoomsForYou
            {/* <i className="fa fa-heart heart text-danger"></i> 
            <a href="#"></a> */}
        </div>
        {/* <div>
            Distributed by
            <a target="_blank" href="#">RoomsForYou</a>.
        </div> */}
    </div></div>
       
    );
}

export default Footer;
